



















import { Vue, Component } from 'vue-property-decorator'
import BaseEnroll from './components/common/BaseEnroll.vue'
import ArtStudentEnrollForm from './components/ArtStudentEnrollForm.vue'
import { ConfigStore } from '@/store/config'
import {
  fetchArtStudentEnroll,
  updateArtStudentEnroll,
  createArtStudentEnroll
} from '@/apis/enroll/artStudent'

@Component({
  components: { BaseEnroll, ArtStudentEnrollForm }
})
export default class ArtStudent extends Vue {
  ajaxFetch = fetchArtStudentEnroll
  ajaxCreate = createArtStudentEnroll
  ajaxUpdate = updateArtStudentEnroll
  form = {
    studentId: '',
    collegeExaminationNumber: '',
    idNumber: '',
    name: '',
    sex: 0,
    birthYear: '',
    birthMonth: '',
    politicalLandscape: '',
    national: '',
    contactTelephone: '',
    graduationSchoolProvince: '',
    graduationSchoolCity: '',
    graduationSchoolName: '',
    sendAddress: '',
    collegeExaminationLocation: '',
    zipCode: '',
    isFreshGraduation: 1,
    homeTelephone: '',
    telephone: '',
    chooseMajor: '',
    height: '',
    width: '',
    stringPoint: '',
    firstSubject: '',
    secondSubject: '',
    musicalInstrument: '',
    homeCallName1: '',
    homeRealName1: '',
    homeWorkCompany1: '',
    homePosition1: '',
    homeCallName2: '',
    homeRealName2: '',
    homeWorkCompany2: '',
    homePosition2: '',
    homeCallName3: '',
    homeRealName3: '',
    homeWorkCompany3: '',
    homePosition3: '',
    lifeDetailAndAward: '',
    remark: '',
    id: '',
    createTime: ''
  }
  nowDate = new Date();

  get config() {
    return ConfigStore.configs.find(a => a.key === 'art-student')?.value ?? {}
  }
  notice = this.nowDate.getFullYear()+this.config.notice
  title = this.nowDate.getFullYear()+this.config.title
}
